var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEggHeartCracked = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 43 44",
    ref: ref,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{isolation:isolate;}.b,.e,.m{opacity:0.2;}.c,.d{fill:#231f20;}.c,.g,.j{opacity:0.4;}.e,.m{fill:#0f272a;}.e{mix-blend-mode:multiply;}.f{fill:#fff;}.h,.j{fill:#eadab5;}.i{fill:#e6e6e6;}.k{fill:#faac3d;}.l{fill:#f89a2e;}.n{fill:url(#a);}.o{fill:url(#b);}.p{fill:url(#c);}.q{fill:url(#d);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 132.26,
    cy: -30.05,
    r: 18.84,
    gradientTransform: "translate(-121.74 3.3) rotate(25.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#e4e3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#d7d6d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#c2c0ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b9b6af"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 132.18,
    cy: -28.16,
    r: 18.84,
    gradientTransform: "translate(-121.74 3.3) rotate(25.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fafafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#edecea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#d7d5d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b9b6af"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: -112.22,
    cy: -174.56,
    r: 12.31,
    gradientTransform: "translate(136.23 -167.32) rotate(-117.43)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 371.36,
    cy: -1089.79,
    r: 12.85,
    gradientTransform: "translate(-1104.46 185.44) rotate(62.57)",
    xlinkHref: "#b"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "egg-heart-cracked") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 18.88,
    cy: 20.26,
    rx: 7.44,
    ry: 7.71,
    transform: "translate(-7.65 28.19) rotate(-63.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M22.32,13.86a6.8,6.8,0,0,0-9.17,2.91,6.81,6.81,0,0,0,3.24,9.06,6.8,6.8,0,0,0,9.17-2.92A6.8,6.8,0,0,0,22.32,13.86Zm-1,.09a5.9,5.9,0,0,1,4.37,5.69S24.28,15,21.34,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M18,25a6.79,6.79,0,0,1-3.24-9,6.55,6.55,0,0,1,1.89-2.3A6.54,6.54,0,0,0,13,16.85a6.79,6.79,0,0,0,3.24,9,7,7,0,0,0,7.28-.62A7,7,0,0,1,18,25Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M3,17.64A4.58,4.58,0,0,0,3.2,20a6.1,6.1,0,0,0,.55,1l2,2.94a7.3,7.3,0,0,0,1.54,1.82,12.24,12.24,0,0,1,1,.7c.45.4.31.8.54,1.24a6,6,0,0,0,1.51,1.41c1.29,1,1.84,2.76,3.36,3.58.71.38,1.53.51,2.28.82,1.07.44,1.84,1.58,2.8,2.25a4.54,4.54,0,0,0,2.42,1.21,6.4,6.4,0,0,0,3.55-.77,25.13,25.13,0,0,0,3.7-4.08,34.84,34.84,0,0,0,5.36-10.2,16.52,16.52,0,0,0,1-5.73,9.68,9.68,0,0,0-.6-2.1,16.8,16.8,0,0,1-.27-3.62A6.13,6.13,0,0,0,33.77,9a5.94,5.94,0,0,0-2.3-2.85,15.56,15.56,0,0,0-2.72-2C27.09,3.38,25,4,23.26,4c-2.36,0-3.51,4.33-5.93,4.5s-3.62-3.61-7.14-2.13a11.81,11.81,0,0,0-5.47,4.21c-1.29,2-1.23,4.14-1.59,6.39C3.09,17.18,3.06,17.41,3,17.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2.6,17.57a4.69,4.69,0,0,0,.17,2.36,5.46,5.46,0,0,0,.56,1c.65,1,1.3,2,2,2.94a6.9,6.9,0,0,0,1.54,1.82,11.64,11.64,0,0,1,1,.71c.44.39.3.79.53,1.23A6.2,6.2,0,0,0,9.89,29c1.29,1,1.85,2.75,3.36,3.57.71.38,1.54.51,2.29.82,1.07.44,1.83,1.58,2.79,2.25.77.54,2.16,1.92,3.16,2s2.08-.89,2.81-1.51A24.68,24.68,0,0,0,28,32a34.48,34.48,0,0,0,5.36-10.2,16.77,16.77,0,0,0,1-5.73,11,11,0,0,0-.6-2.1,16.8,16.8,0,0,1-.28-3.62,6.13,6.13,0,0,0-.17-1.42A5.94,5.94,0,0,0,31,6.09a15.56,15.56,0,0,0-2.72-2c-1.65-.79-3.75-.15-5.49-.18-2.35,0-3.5,4.32-5.93,4.49S13.28,4.8,9.76,6.28a11.88,11.88,0,0,0-5.47,4.21c-1.28,2-1.23,4.14-1.59,6.39C2.66,17.11,2.63,17.34,2.6,17.57Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "g"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M7.42,25.58c-.31-.27-.69-.46-1-.7a7.1,7.1,0,0,1-1.54-1.82l-2-2.94-.13-.2h0a5.46,5.46,0,0,0,.56,1l2,2.94a6.9,6.9,0,0,0,1.54,1.82c.31.23.67.41,1,.67A1.21,1.21,0,0,0,7.42,25.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M33.79,14a16.8,16.8,0,0,1-.28-3.62,6.13,6.13,0,0,0-.17-1.42,3.67,3.67,0,0,0-.56-1.14,2.32,2.32,0,0,1,.13.37,6.14,6.14,0,0,1,.18,1.42,16.8,16.8,0,0,0,.27,3.62,9.68,9.68,0,0,1,.6,2.1,17,17,0,0,1-1,5.73,35.08,35.08,0,0,1-5.36,10.2,25.19,25.19,0,0,1-3.71,4.08c-.72.62-1.77,1.54-2.8,1.51s-2.39-1.41-3.16-1.95c-1-.67-1.73-1.81-2.8-2.25-.75-.31-1.57-.44-2.29-.82-1.51-.82-2.06-2.54-3.35-3.58a10.67,10.67,0,0,1-1.22-1,2.05,2.05,0,0,0,.13.37A6.2,6.2,0,0,0,9.89,29c1.29,1,1.85,2.75,3.36,3.57.71.38,1.54.51,2.29.82,1.07.44,1.83,1.58,2.79,2.25.77.54,2.16,1.92,3.16,2s2.08-.89,2.81-1.51A24.68,24.68,0,0,0,28,32a34.48,34.48,0,0,0,5.36-10.2,16.77,16.77,0,0,0,1-5.73A11,11,0,0,0,33.79,14Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M19.76,11.41a7.7,7.7,0,1,1-7.9,7.48A7.71,7.71,0,0,1,19.76,11.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M12,18.65a6.91,6.91,0,1,0,7.1-6.71A6.91,6.91,0,0,0,12,18.65Zm.51.85s-1-4,3.45-6.33C16,13.17,12.27,16.4,12.55,19.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M24.35,18a6.91,6.91,0,0,1-7.1,6.72,6.75,6.75,0,0,1-3-.77,6.91,6.91,0,1,0,8-11.09A6.85,6.85,0,0,1,24.35,18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M19.9,36.42c-2.78,6-8.73,7.56-12.31,5.9C3.53,40.43,1.42,35,4.2,29A16.53,16.53,0,0,1,5.45,26.8l.36,1.75,1.43.29.69.7L10,29.25l.24,1.68L11,31l.55,1.45,2.34-.5,1.35,1.64,2.25-.24.35.87,1.85,0,.62,1.34C20.16,35.82,20,36.12,19.9,36.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M19.87,35.06c-2.78,6-8.37,6.86-12,5.2-4.06-1.89-6.11-6.49-3.33-12.45.36-.76,0-.76.44-1.46l.88-.21.38.79L8,26.84l.88,1.09,2.48.09.72.06.31.63,2.2,0,2.15,2.62h1l.35.87,1.57.65.16,2.26C19.75,35.37,20,34.76,19.87,35.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M19.53,35.85c-2.78,6-8.62,7.8-12.3,5.9C2.89,39.52,1.06,34.4,3.84,28.44A15,15,0,0,1,5.06,26.3L5.45,28l1.43.29.69.7,2.08-.29.3,1.68.74.08.52,1.34,2.33-.51L14.88,33l2.22-.2.35.86,1.85,0L19.91,35C19.79,35.29,19.67,35.56,19.53,35.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M19.48,36c-2.78,6-8.72,7.57-12.3,5.9C3.11,40,1,34.51,3.79,28.55A15.89,15.89,0,0,1,5,26.35l.36,1.75,1.43.29.7.7,2.07-.29.24,1.68.72.06L11.1,32l2.35-.51,1.34,1.65,2.26-.24.34.87,1.86,0,.62,1.35Q19.69,35.52,19.48,36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M41.85,9.3C40.09,5.9,34.07,5,28.77,6.72v0l-.11,0L27.3,8.66l.46.55-.67,1.16,1,1.42-.82,1.44L28,14l-.2.62,2.11,2.1-.16,1.6,2.43,1.37.25.89,2.24.72L35,22.38l.12-.08v0C40.33,19.17,43.78,13,41.85,9.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M35,22.05l-.26-1.11-2.24-.73-.25-.88L29.78,18l.16-1.59-2.11-2.1.2-.63-.77-.73.82-1.45-1-1.41.67-1.16-.46-.55,1.35-1.88c5.3-1.77,10.73-.52,12.5,2.88C43.07,13,40.2,18.9,35,22.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M35,22.05l.32-1.41L33.9,19.21l.17-.53-1.9-1.16-.06-2.07-2.12-1L30.43,13l-.52-.48.82-1.44-1.79-1-.12-1L27.89,8l.76-1.57C34,4.68,40,5.63,41.73,9,43.66,12.74,40.2,18.9,35,22.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M35.08,22l.32-1.42L34,19.15l.17-.53-1.9-1.16,0-2.08-2.13-1,.44-1.45L30,12.45,30.85,11l-1.79-1-.12-1L28,8l.76-1.57C34.07,4.62,40.09,5.56,41.85,9,43.78,12.68,40.33,18.84,35.08,22Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEggHeartCracked);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/egg-heart-cracked.ed66028b5a18c32b86ab4888a8f59beb.svg";